import { Box, Modal } from "@mui/material";
import { useMyContext } from "../../context";
import { modalStyle } from "../../MUIStyles";
import DialogsButtons from "../DialogsButtons";
const Confirm = ({ title, subTitle, loading, fun }) => {
  const { handleCloseModal, modalStates, setId } = useMyContext();
  const closeModal = () => {
    setId("");
    handleCloseModal("confirm");
  };
  return (
    <Modal open={modalStates.confirm} onClose={closeModal}>
      <Box
        sx={{
          ...modalStyle,
          maxHeight: "90vh",
          width: { lg: "600px", xs: "400px" },
          overflow: "hidden",
        }}
      >
        <div className="flex flex-col items-center gap-5 font-semibold">
          <h3 className="lg:text-2xl text-xl font-bold">{title}</h3>
          <p className="text-center">{subTitle}</p>
          <DialogsButtons
            Btn1="Cancel"
            Btn2={loading ? "Confirming..." : "Confirm"}
            color="bg6"
            onClick={fun}
            onClose={closeModal}
            disable={loading}
          />
        </div>
      </Box>
    </Modal>
  );
};

export default Confirm;
